import { render, staticRenderFns } from "./ActivityStatusCard.vue?vue&type=template&id=7060c77f"
import script from "./ActivityStatusCard.vue?vue&type=script&lang=js"
export * from "./ActivityStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports